function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.712524V29.3683H17.719V23.6077H6.43798V0.712524H0Z",
  fill: "#00629B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.2644 8.82407C35.6559 8.82407 40.2375 12.6779 40.2375 19.4971C40.2375 26.3164 35.6617 30 29.2644 30C22.8671 30 18.335 26.3077 18.335 19.4914C18.335 12.675 22.87 8.8183 29.2673 8.8183L29.2644 8.82407ZM29.2673 25.2866C32.1232 25.2866 33.9157 23.0856 33.9157 19.402C33.9157 15.6346 32.1522 13.4741 29.2673 13.4741C26.3824 13.4741 24.648 15.675 24.648 19.402C24.648 23.1289 26.4115 25.2866 29.2673 25.2866Z",
  fill: "#00629B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2942 8.82404C58.6857 8.82404 63.2673 12.6779 63.2673 19.4971C63.2673 26.3163 58.7002 30 52.2942 30C45.8882 30 41.3647 26.3163 41.3647 19.5C41.3647 12.6837 45.9027 8.82692 52.2942 8.82692V8.82404ZM52.2942 25.2952C55.15 25.2952 56.9426 23.0942 56.9426 19.4106C56.9426 15.6433 55.1791 13.4827 52.2942 13.4827C49.4093 13.4827 47.6749 15.6837 47.6749 19.4106C47.6749 23.1375 49.4384 25.2952 52.2942 25.2952Z",
  fill: "#00629B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M70.9891 0V15.8683L77.4706 9.22212H85.6983L77.4271 17.0567L86.2967 29.374H78.6211L72.9501 21.1615L70.9891 22.9817V29.374H64.7632V0H70.9891Z",
  fill: "#00629B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M104.608 25.1509C103.414 26.8442 100.471 29.9336 94.8874 29.9336C88.9172 29.9336 84.356 26.0394 84.356 19.2606C84.356 12.9519 88.7138 8.76056 94.7596 8.76056C101.442 8.76056 104.864 13.5433 104.864 19.6846C104.871 20.1081 104.857 20.5318 104.82 20.9538H90.3524C90.5644 23.1548 92.1856 25.0615 95.2564 25.0615C97.3199 25.1041 99.2451 24.0347 100.288 22.2663L104.608 25.1509ZM90.3524 16.9788H98.8385C98.7107 14.6509 97.2174 13.0413 94.7015 13.0413C92.2698 13.0413 90.4366 14.8615 90.3436 16.9788H90.3524Z",
  fill: "#00629B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M113.15 9.27403V12.026C113.705 10.5029 116.006 8.80961 118.865 8.80961C119.107 8.80298 119.349 8.81746 119.588 8.85288V14.7779C118.932 14.6181 118.259 14.5329 117.583 14.524C115.195 14.524 114.001 15.6779 113.533 17.3596C113.318 18.246 113.22 19.1566 113.243 20.0683V29.4231H107.011V9.27403H113.15Z",
  fill: "#00629B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M135.674 15.4125C134.17 14.0285 132.205 13.2448 130.154 13.2115C128.748 13.2115 127.511 13.6788 127.511 14.6942C127.511 15.7096 128.449 16.05 130.538 16.4711L133.734 17.149C137.016 17.8269 140 19.1394 140 22.9904C140 27.6894 135.863 29.9336 131.046 29.9336C126.398 29.9336 122.476 27.9144 120.643 25.4048L124.565 22.2721C125.802 23.9654 128.231 25.3615 131.046 25.3615C133.135 25.3615 134.201 24.6836 134.201 23.5846C134.201 22.4856 132.964 22.2288 131.587 21.975L128.411 21.3461C126.377 20.9654 124.617 20.2875 123.379 19.2288C122.222 18.2502 121.58 16.7995 121.636 15.2913C121.636 10.5086 126.285 8.77209 130.294 8.77209C134.088 8.77209 137.127 10.1682 139.161 12.1154L135.674 15.4125Z",
  fill: "#00629B"
});

function SvgLookersLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 30,
    viewBox: "0 0 140 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookersLogo);
export default __webpack_public_path__ + "static/media/LookersLogo.212ac73b.svg";
export { ForwardRef as ReactComponent };